import '../collection-action-menu/collection-action-menu.js';
import '../wishlist-collection-head/wishlist-collection-head.js';
import { CSSResult, html, LitElement, nothing, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Messages } from '../../../@types/wishlist.js';
import { consume } from '@lit/context';
import { i18nContext } from '../../../scripts/context/i18nContext.js';
import { sharedCss } from '../../../scripts/style-bundle/shared.js';
import styles from './wishlist-collection-details-error.scss?inline';
import { WishlistAppConfig, wishlistAppConfigContext } from '../../../scripts/context/appConfigContext.js';

export enum DetailsError {
  NOT_LOGGED_IN,
  COLLECTION_NOT_EXISTS,
}

@customElement('ents-wishlist-collection-details-error')
export class WishlistCollectionDetailsError extends LitElement {
  @property({ attribute: 'error' })
  private error!: DetailsError;

  @consume({ context: i18nContext })
  private messages!: Messages;

  @consume({ context: wishlistAppConfigContext })
  private wishlistAppConfig!: WishlistAppConfig;

  static get styles(): CSSResult[] {
    return [sharedCss, unsafeCSS(styles)];
  }

  private renderNotLoggedInError() {
    return this.renderError(
      'not-logged-in',
      this.messages['ents_wishlist_collection_details_login_hint_title']!,
      this.messages['ents_wishlist_collection_details_login_hint_text']!,
      this.messages['ents_wishlist_collection_details_login_hint_link_text'],
      this.wishlistAppConfig.loginEndpointWithCollectionReferrer,
    );
  }

  private renderWishlistNotExists() {
    return this.renderError(
      'not-existing',
      this.messages['ents_wishlist_collection_details_not_exist_title']!,
      this.messages['ents_wishlist_collection_details_not_exist_text']!,
    );
  }

  private renderError(testId: string, title: string, text: string, linkText?: string, linkHref?: string) {
    return html`
      <div class="ents-wishlist-collection-details-error" data-test-ents-colletion-details-error="${testId}">
        <p>
          <span class="ents-copy-bold">${title}</span>
          ${linkText && linkHref
            ? html`<a class="bdk-link-inline" href="${linkHref}">${linkText}</a>&nbsp;`
            : nothing}<span>${text}</span>
        </p>
      </div>
    `;
  }

  render() {
    switch (this.error) {
      case DetailsError.NOT_LOGGED_IN:
        return this.renderNotLoggedInError();
      case DetailsError.COLLECTION_NOT_EXISTS:
        return this.renderWishlistNotExists();
      default:
        return nothing;
    }
  }
}
